import { Model, Store, Casts } from 'store/Base';
import { observable } from 'mobx';

export const ENTRY_TYPE_PLANNED = 'planned';
export const ENTRY_TYPE_SUPPORT = 'support';

export class TimeEntry extends Model {
    static backendResourceName = 'planning_time_entry';

    @observable id = null;
    @observable user: any = null;
    @observable project: any = null;
    @observable ticket: any = null;
    @observable date = null;
    @observable hours = 0;
    @observable entryType = ENTRY_TYPE_PLANNED;
    @observable description = '';

    casts() {
        return {
            date: Casts.date,
        };
    }
}

export class TimeEntryStore extends Store {
    Model = TimeEntry;
    static backendResourceName = 'planning_time_entry';
}
